import React from 'react';

const AppStoreDownload = ({ appUrl }) => {
  const appStoreImageUrl = 'https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg';

  return (
    <a
      href={appUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="app-store-badge"
    >
      <img
        src={appStoreImageUrl}
        alt="Download on the App Store"
      />
    </a>
  );
};

export default AppStoreDownload;
